<template>
  <v-layout row wrap gap>
    <template v-if="isSmallSuggestion && smallSuggestionImages.length">
      <v-flex lg12 xs12>
        <p class="ma-0 suggestion-font pa-0">
          {{ $t('message.bizgainOnboarding.suggestions') }}
        </p>
      </v-flex>
      <v-flex
        v-for="(image,index) in smallSuggestionImages"
        :key="index"
        shrink
      >
        <v-layout
          align-center
          justify-center
        >
          <business-image-card
            :business-image="image"
            @selectBusinessImage="selectFromSmallSuggestion"
            :height="businessImageCardHeight"
            :width="businessImageCardHeight"
            :is-dimension="false"
          />
        </v-layout>
      </v-flex>
    </template>
    <v-flex xs12>
      <v-layout
        mr-1
        :class="{'upload-btn-margin': isSmallSuggestion && !businessLogo, 'justify-center': isForSummary}"
        align-center
        v-show="(isFirstImageProcessedInSuggestions || isImagesInitialized)"
      >
        <v-btn
          @click="onFilePicked"
          depressed
          class="no-background-hover pa-0"
          color="primary"
          outline
          v-if="((businessLogo && isSmallSuggestion && !isFirstImageProcessedInSuggestions && !uploadedImages.length && !isFbAccessTokenExpired) || (!businessLogo && !isFirstImageProcessedInSuggestions && !uploadedImages.length && isSmallSuggestion && !isFbAccessTokenExpired) && !isSubsequent)"
          :disabled="isImageUploading"
        >
          {{ $tc('message.upload') }}
        </v-btn>
        <span
          v-else
          @click="handleModalClick"
          flat
          solo
          v-ripple="false"
          class="no-background-hover pa-0 modal-text"
        >
          <slot name="open-dialog" />
        </span>
      </v-layout>
      <input
        type="file"
        @change="onChange"
        ref="logo"
        accept=".jpg,.jpeg,.png"
        style="display:none;"
      >
      <v-dialog
        v-model="dialog"
        max-width="1000px"
        :persistent="true"
      >
        <div :style="{height:'10px', 'margin-bottom':'15px'}" class="text-xs-right">
          <v-btn
            class="close-button no-background-hover ma-0 mr-2 pa-0"
            flat
            top
            right
            v-ripple="false"
            @click="dialog=false"
          >
            <v-icon class="material-icon theme--light ">
              close
            </v-icon>
          </v-btn>
        </div>
        <v-layout
          row
          wrap
          mx-3
          class="draggable-section"
        >
          <v-flex
            my-2
            class="draggable-section"
            :class="{'upload-logo': !isUploadedImageDragged, 'upload-logo-dragged': isUploadedImageDragged}"
            @drop="drop"
            @dragenter="dragEnter"
            @dragleave="dragLeave"
            @dragover.prevent
            lg12
          >
            <span class="text-xs-center my-3 draggable-section-child-element">
              <span
                class="text-decoration-underline primary--text draggable-section-child-element"
                style="cursor:pointer;"
                @click="onFilePicked"
              >
                {{ $t('message.bizgainOnboarding.Upload') }}
              </span>
              <span v-if="$vuetify.breakpoint.xsOnly">
                <span v-show="this.isStockImageSet">
                  {{ $t('message.bizgainOnboarding.uploadLeadImage') }}
                </span>
                <span v-show="!this.isStockImageSet">
                  {{ $t('message.bizgainOnboarding.uploadLogoImage') }}
                </span>
              </span>
              <span v-else>
                <span v-show="this.isStockImageSet">
                  {{ $t('message.bizgainOnboarding.dropLeadImage') }}
                </span>
                <span v-show="!this.isStockImageSet">
                  {{ $t('message.bizgainOnboarding.dropLogo') }}
                </span>
              </span>

              <pre />
              <span v-show="!this.isStockImageSet"> {{ $t('message.bizgainOnboarding.dimension') }}</span>
            </span>
            <span class="mb-2 mx-2 draggable-section-child-element text-center red--text upload-image-error-text">
              <span v-show="isUploadedImageInvalid">{{ uploadImageValidationMessage }}</span>
            </span>
          </v-flex>
          <v-flex lg12>
            <v-tabs
              v-model="activeTab"
              color="white"
              :hide-slider="true"
              active-class="active-tab"
              ref="tabs"
            >
              <div id="g-map-container" />
              <v-tab v-for="(image) in businessImage.filter(img => (img.id === businessImageType.CustomUpload) ? uploadedImages.length : img )" :key="image.id" @click="selectTab(image)">
                {{ $t(image.title) }}
              </v-tab>
              <v-tab-item v-for="(item) in businessImage.filter(img => (img.id === businessImageType.CustomUpload) ? uploadedImages.length : img )" :key="item.id">
                <div v-if="item.id === businessImageType.GoogleMyBusiness && isGoogleMapImageSet">
                  <v-layout
                    justify-center
                    align-center
                    mt-2
                    v-if="isGoogleMapImageLoading"
                  >
                    <v-progress-circular size="50" indeterminate />
                  </v-layout>
                  <v-layout
                    justify-center
                    align-center
                    mt-2
                    v-else-if="!googlePlaceDetails.imageUrls.length"
                  >
                    {{ $t('message.bizgainOnboarding.noImageFound') }}
                  </v-layout>
                  <v-layout
                    row
                    wrap
                    mt-2
                    v-else
                  >
                    <vue-perfect-scrollbar
                      :settings="settings"
                      class="scroll-container"
                      ref="scroll"
                    >
                      <v-container
                        grid-lg
                        fluid
                        pt-0
                        px-0
                        class="scroll-area"
                      >
                        <v-layout
                          row
                          wrap
                        >
                          <v-flex
                            lg2
                            xs6
                            md2
                            sm4
                            v-for="(image,index) in googleMapProcessedImages"
                            :key="index"
                            class="logo-preview"
                          >
                            <v-layout
                              align-center
                              justify-center
                            >
                              <business-image-card :business-image="image" @selectBusinessImage="selectImage" />
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </vue-perfect-scrollbar>
                  </v-layout>
                </div>
                <div v-if="item.id === businessImageType.Website">
                  <v-layout
                    justify-center
                    align-center
                    mt-2
                    v-if="isWebsiteImageLoading"
                  >
                    <v-progress-circular size="50" indeterminate />
                  </v-layout>
                  <v-layout
                    justify-center
                    align-center
                    mt-2
                    v-else-if="!websiteImagesResponse.length"
                  >
                    {{ $t('message.bizgainOnboarding.noImageFound') }}
                  </v-layout>
                  <v-layout
                    row
                    wrap
                    mt-2
                    v-else
                  >
                    <vue-perfect-scrollbar
                      :settings="settings"
                      class="scroll-container"
                      ref="scroll"
                    >
                      <v-container
                        grid-lg
                        fluid
                        pt-0
                        px-0
                        class="scroll-area"
                      >
                        <v-layout
                          row
                          wrap
                        >
                          <v-flex
                            lg2
                            xs6
                            md2
                            sm4
                            v-for="(image,index) in websiteBusinessProcessedImages"
                            :key="index"
                            class="logo-preview"
                          >
                            <v-layout
                              align-center
                              justify-center
                            >
                              <business-image-card :business-image="image" @selectBusinessImage="selectImage" />
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </vue-perfect-scrollbar>
                  </v-layout>
                </div>
                <div v-else-if="item.id === businessImageType.Facebook" class="mt-2">
                  <v-layout
                    justify-center
                    align-center
                    mt-2
                    v-if="isFbBusinessImageLoading"
                  >
                    <v-progress-circular size="50" indeterminate />
                  </v-layout>
                  <v-layout
                    row
                    wrap
                    v-else-if="isFbAccessTokenExpired"
                    mt-1
                  >
                    <v-flex lg12 xs12>
                      <v-alert
                        :value="true"
                        color="info"
                        icon="info"
                        outline
                        class="ma-0 mb-2"
                      >
                        {{ $t('message.bizgainOnboarding.Login') }}
                      </v-alert>
                      <v-progress-circular size="20" indeterminate v-if="isFbLoadCompleted" />
                      <link-facebook @LinkedPageDetails="getFacebookPageDetails" v-show="!isFbLoadCompleted" />
                    </v-flex>
                    <v-flex shrink>
                      <v-btn
                        @click="setFacebookDetail"
                        v-if="facebookDetails"
                        color="primary"
                        solo
                      >
                        {{ $t('message.bizgainOnboarding.loadImages') }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout
                    justify-center
                    align-center
                    mt-2
                    v-else-if="!facebookImagesResponse.length"
                  >
                    {{ $t('message.bizgainOnboarding.noImageFound') }}
                  </v-layout>
                  <v-layout
                    row
                    wrap
                    v-else
                  >
                    <vue-perfect-scrollbar
                      :settings="settings"
                      class="scroll-container"
                      ref="scroll"
                    >
                      <v-container
                        grid-lg
                        fluid
                        pt-0
                        px-0
                        class="scroll-area"
                      >
                        <v-layout
                          row
                          wrap
                        >
                          <v-flex
                            lg2
                            xs6
                            md2
                            sm4
                            v-for="(image,index) in facebookBusinessProcessedImages"
                            :key="index"
                            class="logo-preview"
                          >
                            <v-layout
                              align-center
                              justify-center
                            >
                              <business-image-card :business-image="image" @selectBusinessImage="selectImage" />
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </vue-perfect-scrollbar>
                  </v-layout>

                  <v-alert
                    color="error"
                    icon="error"
                    :value="isFacebookImageError"
                    outline
                    class="ma-0 mb-2"
                  >
                    {{ $t('message.bizgainOnboarding.fbImageError') }}
                  </v-alert>
                </div>
                <div v-if="(item.id === businessImageType.StockImage) && isStockImageSet">
                  <stock-image
                    ref="stockImage"
                    :preset-search-item="presetImage"
                    :business-category="businessDetails.category.displayName"
                    :is-stock-image-active="isStockImageActive"
                    @selectImage="selectImage"
                    @setPresetImage="setPresetImageItem"
                  />
                </div>
                <v-layout
                  row
                  wrap
                  mt-2
                  v-else-if="(item.id === businessImageType.CustomUpload)"
                >
                  <vue-perfect-scrollbar
                    :settings="settings"
                    class="scroll-container"
                    ref="scroll"
                  >
                    <v-container
                      grid-lg
                      fluid
                      pt-0
                      px-0
                      class="scroll-area"
                    >
                      <v-layout
                        row
                        wrap
                      >
                        <v-flex
                          lg2
                          xs6
                          md2
                          sm4
                          v-for="(image,index) in uploadedImages"
                          :key="index"
                          class="logo-preview"
                        >
                          <v-layout
                            align-center
                            justify-center
                          >
                            <business-image-card :business-image="image" @selectBusinessImage="selectImage" />
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </vue-perfect-scrollbar>
                </v-layout>
              </v-tab-item>
            </v-tabs>
          </v-flex>
          <v-flex lg12 mb-1>
            <v-divider light class="mb-1" />
            <v-layout row wrap>
              <v-flex lg2 xs4>
                <v-btn
                  color="primary"
                  @click="setLogo"
                  depressed
                  :disabled="!imageSelected"
                >
                  {{ $t('message.bizgainOnboarding.continue') }}
                </v-btn>
              </v-flex>
              <v-flex lg2 xs2>
                <v-btn
                  @click="dialog=false"
                  outline
                  color="primary"
                >
                  {{ $t('message.bizgainOnboarding.cancel') }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>
<script>
import {
  VTabs,
  VTab,
  VTabItem,
  VDialog,
  VLayout,
  VFlex,
  VDivider,
  VIcon,
  VProgressCircular,
  VAlert,
  VContainer } from 'vuetify/lib';
import { mapGetters, mapActions } from 'vuex';
import { GoogleMapHelper } from 'Features/bizgainOnboarding/helpers/googleMapHelper';
import { businessImageType, imageTypes, sortType, suggestedBusinessImageCount } from 'Features/bizgainOnboarding/constants';
import { ApiService } from 'Features/bizgainOnboarding/services/apiService';
import LinkFacebook from '../../pages/businessDetails/components/LinkFacebook.vue';
import BusinessImageCard from '../BusinessImages/components/BusinessImageCard.vue';
import StockImage from '../BusinessImages/components/StockImage.vue';
const { getBusinessImages, getRoimaticImages } = new ApiService();
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { i18n } from '@/lang/';
export default {
  props: {
    isSmallSuggestion: {
      default: true,
      type: Boolean
    },
    isStockImageSet: {
      default: false,
      type: Boolean
    },
    isGoogleMapImageSet: {
      default: false,
      type: Boolean
    },
    isForCreative: {
      default: false,
      type: Boolean
    },
    isForSummary: {
      default: false,
      type: Boolean
    }
  },
  components: {
    VTabs,
    VTab,
    VTabItem,
    VDialog,
    VLayout,
    VFlex,
    VDivider,
    VIcon,
    LinkFacebook,
    VProgressCircular,
    VAlert,
    VContainer,
    BusinessImageCard,
    StockImage,
    VuePerfectScrollbar
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 30,
        suppressScrollX: true
      },
      dialog: false,
      activeTab: 0,
      facebookBusinessProcessedImages: [],
      websiteBusinessProcessedImages: [],
      googleMapProcessedImages: [],
      stockBusinessImages: [],
      roimaticImages: [],
      imageSelected: null,
      isLoading: true,
      smallSuggestionImages: [],
      isFbAccessTokenExpired: false,
      facebookDetails: null,
      isFbBusinessImageLoading: false,
      isWebsiteImageLoading: false,
      isGoogleMapImageLoading: false,
      isFbBusinessAllImagesProcessed: false,
      isWebsiteAllImageProcessed: false,
      isGoogleMapAllImageProcessed: false,
      businessImage: [],
      businessImageType,
      isFacebookImageError: false,
      isStockImageActive: false,
      totalSuggestionImages: 0,
      googleMapObj: null,
      googleMapHelper: null,
      placeDetails: null,
      googleSessionToken: null,
      isUploadedImageDragged: false,
      isUploadedImageInvalid: false,
      isImageUploading: false,
      facebookImagesResponse: [],
      websiteImagesResponse: [],
      suggestedBusinessImageCount,
      selectedTabId: 0,
      isFirstImageProcessedInSuggestions: false,
      isImagesInitialized: false
    }
  },
  async created() {
    try {
      this.totalSuggestionImages = 0;
      this.$emit('setIsImageUploading', true);
      this.isLeadImage = this.isStockImageSet;

      this.businessImage.push({
        id: this.businessImageType.CustomUpload,
        title: 'message.bizgainOnboarding.uploadedImage',
        images: this.uploadedImages
      });

      if (this.facebookPageDetail && this.facebookPageDetail.id && this.facebookPageDetail.accessToken) {
        this.businessImage.push({
          id: this.businessImageType.Facebook,
          title: 'message.bizgainOnboarding.facebook'
        });
      }

      if(this.websiteUrl || (this.googlePlaceDetails && this.googlePlaceDetails.website) || (this.facebookPageDetail && this.facebookPageDetail.website))
      {
        this.businessImage.push({
          id: this.businessImageType.Website,
          title: 'message.bizgainOnboarding.website'
        });
      }

      if (this.googlePlaceDetails && this.googlePlaceDetails.imageUrls && this.isGoogleMapImageSet)
      {
        this.businessImage.push({
          id: this.businessImageType.GoogleMyBusiness,
          title: 'message.bizgainOnboarding.googleMyBusiness'
        });
      }

      if(this.isStockImageSet){
        this.businessImage.push({
          id: this.businessImageType.StockImage,
          title: 'message.bizgainOnboarding.stockImage',
          images: []
        });
      }

      await this.getCustomUploadedImages();
      if(this.isSmallSuggestion){
        await this.getFacebookBusinessImages(false);
        await this.getWebsiteBusinessImages(false);
        await this.getGoogleMapBusinessImages(false);
      }
    } finally {
      this.$emit('setIsImageUploading', false);
      this.isLoading = false;
      this.setIsBusinessLogoModalEnabled(true);
      this.isImagesInitialized = true
      this.$emit('initialize');
    }
  },
  computed: {
    ...mapGetters(['websiteUrl',
      'facebookPageDetail',
      'isFbLoadCompleted',
      'businessDetails',
      'businessLogo',
      'presetImage',
      'customUploadedLogoImages',
      'customUploadedLeadImages',
      'businessProfileId',
      'googlePlaceDetails',
      'isBusinessLogoModalEnabled']),
    isSubsequent() {
      return (this.businessProfileId) ? true : false;
    },
    uploadedImages() {
      return (this.isLeadImage) ? this.customUploadedLeadImages : this.customUploadedLogoImages;
    },
    businessImageCardHeight () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 40
        default: return 50
      }
    },
    uploadImageValidationMessage(){
      return (this.isLeadImage) ? i18n.tc('message.uploadLeadImageValidationMessage') : i18n.tc('message.uploadLogoValidationMesssage');
    }
  },
  watch: {
    isImageUploading(){
      this.deselectImageAfterUpload();
    },
    smallSuggestionImages(){
      this.setLogoFromSuggestion();
    },
    async dialog(value){
      if (value && !this.selectedTabId) {
        if(this.uploadedImages && this.businessImage.length > 1){
          this.activeTab = 1;
          this.selectedTabId = this.businessImage[1].id;
        } else{
          this.activeTab = 0;
          this.selectedTabId = this.businessImage[0].id;
        }
      }
    },
    async selectedTabId(tabId) {
      switch(tabId) {
        case this.businessImageType.Facebook:
          await this.getFacebookBusinessImages();
          break;
        case this.businessImageType.Website:
          await this.getWebsiteBusinessImages();
          break;
        case this.businessImageType.GoogleMyBusiness:
          await this.getGoogleMapBusinessImages();
          break;
      }
    }
  },
  methods: {
    ...mapActions(['setIsBusinessLogoModalEnabled', 'setGooglePlaceDetails', 'setFacebookPageDetail', 'setPresetImage', 'setCustomUploadedLogoImages', 'addCustomUploadedLogoImages', 'setCustomUploadedLeadImages', 'addCustomUploadedLeadImages']),
    async mapsInit() {
      this.googleMapHelper = new GoogleMapHelper();
      let googleMapObj = await this.googleMapHelper.mapInitalize(document.getElementById('g-map-container'));
      if (googleMapObj) {
        this.googleMapObj = googleMapObj;
        this.googleSessionToken = this.googleMapObj.sessionToken;
      }
    },
    async getCustomUploadedImages(){
      var uploadedImages = [];
      if(this.businessProfileId){
        var payload = {
          sortType: sortType.descending
        }
        var response = await getRoimaticImages(this.businessProfileId, payload);
        if(response){
          this.roimaticImages = response.images;
        }
        uploadedImages = this.roimaticImages;
      }
      else{
        uploadedImages = (this.businessDetails && this.businessDetails.uploadedImages) || [];
      }
      var newUploadedImages = [];
      if(uploadedImages && uploadedImages.length){
        uploadedImages.forEach(image => {
          try {
            var uploadedImagesData =  {
              url: image.imageUrl,
              dimension: {
                width: image.dimensions.split('x')[1],
                height: image.dimensions.split('x')[0]
              },
              selected: false,
              imageSource: businessImageType.CustomUpload,
              type: image.type
            }
            newUploadedImages.push(uploadedImagesData);
          } catch{
          //to skip corrupt images
            return;
          }
        });
      }

      var leadImages = newUploadedImages.filter(image => image.type === 2);
      var logoImages = newUploadedImages.filter(image => image.type === 1);
      this.setCustomUploadedLeadImages(leadImages);
      this.setCustomUploadedLogoImages(logoImages);
    },
    async getFacebookBusinessImages(processAll = true){
      if (this.facebookPageDetail && this.facebookPageDetail.id && this.facebookPageDetail.accessToken && !this.isFbBusinessAllImagesProcessed && !this.isFbBusinessImageLoading) {
        var payload = {
          facebookPageDetail: this.facebookPageDetail,
          type: this.businessImageType.Facebook,
          isLeadImage: this.isStockImageSet
        }
        this.isFbBusinessImageLoading = true;
        this.isFacebookImageError = false;
        this.facebookBusinessProcessedImages = [];
        try {
          if(!this.facebookImagesResponse.length){
            if(this.isSubsequent){
              this.facebookImagesResponse = await getBusinessImages(payload, this.businessProfileId);
            }
            else{
              this.facebookImagesResponse = await getBusinessImages(payload);
            }
          }
          await this.facebookImagesResponse.forEachAsync(async image => {
            try{
              if(!processAll && (this.smallSuggestionImages.length == this.suggestedBusinessImageCount))
              {
                return;
              }
              var imgDimensions = await this.processImage(image.source);
              var fbImages =  {
                url: image.source,
                dimension: {
                  height: imgDimensions.naturalHeight,
                  width: imgDimensions.naturalWidth
                },
                selected: false,
                imageSource: businessImageType.Facebook
              }
              this.facebookBusinessProcessedImages.push(fbImages);
              if(this.isSmallSuggestion && this.smallSuggestionImages.length < this.suggestedBusinessImageCount)
              {
                if(!this.smallSuggestionImages.length)
                {
                  fbImages.selected = true;
                }
                this.smallSuggestionImages = this.smallSuggestionImages.concat(fbImages);
              }
            } catch {
            // skip corrupt images
            }
          });
          if(!processAll)
          {
            this.totalSuggestionImages += this.facebookBusinessProcessedImages.length;
          }
        } catch(error) {
          if(error.response !== undefined && error.response.data.errorCode === 335){
            this.isFbAccessTokenExpired = true;
          } else {
            this.isFacebookImageError = true;
          }
        } finally {
          this.isFbBusinessImageLoading = false;
          this.isFbBusinessAllImagesProcessed = (!this.isFbAccessTokenExpired) && (this.facebookImagesResponse.length == 0 || (this.facebookImagesResponse.length == this.facebookBusinessProcessedImages.length));
        }
      }
    },
    async getWebsiteBusinessImages(processAll = true){
      if(!this.isWebsiteAllImageProcessed && !this.isWebsiteImageLoading && (this.websiteUrl || (this.googlePlaceDetails && this.googlePlaceDetails.website) || (this.facebookPageDetail && this.facebookPageDetail.website))){
        let websiteUrl = null;
        if (this.websiteUrl) {
          websiteUrl = this.websiteUrl;
        } else if (this.facebookPageDetail && this.facebookPageDetail.website) {
          websiteUrl = this.facebookPageDetail.website;
        } else {
          websiteUrl = this.googlePlaceDetails.website;
        }
        var payload = {
          websiteUrl: websiteUrl,
          type: this.businessImageType.Website,
          isLeadImage: this.isStockImageSet,
          businessName: this.businessDetails.name
        }
        this.isWebsiteImageLoading = true;
        this.websiteBusinessProcessedImages = [];
        try {
          if(!this.websiteImagesResponse.length){
            this.websiteImagesResponse = await getBusinessImages(payload);
          }
          await this.websiteImagesResponse.forEachAsync(async image => {
            try {
              if(!processAll && (this.smallSuggestionImages.length == this.suggestedBusinessImageCount))
              {
                return;
              }
              var imgDimensions = await this.processImage(image.source);
              var websiteImage = {
                url: image.source,
                dimension: {
                  width: imgDimensions.naturalWidth,
                  height: imgDimensions.naturalHeight
                },
                selected: false,
                imageSource: businessImageType.Website
              }
              this.websiteBusinessProcessedImages.push(websiteImage);

              if(this.isSmallSuggestion && this.smallSuggestionImages.length < this.suggestedBusinessImageCount)
              {
                if(!this.smallSuggestionImages.length)
                {
                  websiteImage.selected = true;
                }
                this.smallSuggestionImages = this.smallSuggestionImages.concat(websiteImage);
              }
            } catch {
            // we might get some corrupted image from SERP client so we are skipping those images
              return;
            }
          });
        }catch{return;}
        finally {
          this.isWebsiteImageLoading = false;
          this.isWebsiteAllImageProcessed = this.websiteImagesResponse.length == 0 || (this.websiteImagesResponse.length == this.websiteBusinessProcessedImages.length);
          if(!processAll)
          {
            this.totalSuggestionImages += this.websiteBusinessProcessedImages.length;
          }
        }
      }
    },
    async getGoogleMapBusinessImages(processAll = true){
      if (!this.isGoogleMapAllImageProcessed && !this.isGoogleMapImageLoading && (this.googlePlaceDetails && this.googlePlaceDetails.imageUrls && this.isGoogleMapImageSet)){
        this.isGoogleMapImageLoading = true;

        if(this.isSubsequent){
          await this.mapsInit();
          var location = this.googlePlaceDetails.placeId;
          let placeDetails;
          if(!this.googlePlaceDetails.imageUrls.length){
            placeDetails = await this.googleMapHelper.getGoogleMapPlaceDetails(location, this.googleSessionToken, this.googleMapObj.map);
          }
          if (placeDetails) {
            this.placeDetails = placeDetails.googlePlaceDetails;
            this.googleSessionToken = placeDetails.sessionToken;
            if(this.placeDetails && this.placeDetails.photos){
              var imageUrls = [];
              for (var i = 0 ; i < this.placeDetails.photos.length ; i++)
              {
                var imageUrl = this.placeDetails.photos[i].getUrl({ maxWidth: 1080, maxHeight: 1080 });
                imageUrls.push(imageUrl);
              }
              this.placeDetails.imageUrls = imageUrls;
            }
            this.setGooglePlaceDetails(this.placeDetails);
          }
        }

        this.googleMapProcessedImages = [];
        await this.googlePlaceDetails.imageUrls.forEachAsync(async image => {
          try {
            if(!processAll && (this.smallSuggestionImages.length == this.suggestedBusinessImageCount))
            {
              return;
            }
            var imgDimensions = await this.processImage(image);
            var googleMapImages =  {
              url: image,
              dimension: {
                width: imgDimensions.naturalWidth,
                height: imgDimensions.naturalHeight
              },
              selected: false,
              imageSource: businessImageType.GoogleMyBusiness
            }
            this.googleMapProcessedImages.push(googleMapImages);
            if(this.isSmallSuggestion && this.smallSuggestionImages.length < this.suggestedBusinessImageCount)
            {
              if(!this.smallSuggestionImages.length)
              {
                googleMapImages.selected = true;
              }
              this.smallSuggestionImages = this.smallSuggestionImages.concat(googleMapImages);
            }
          } catch {
          //to skip corrupt images
            return;
          }
        })
        this.isGoogleMapImageLoading = false;
        this.isGoogleMapAllImageProcessed = this.googlePlaceDetails.imageUrls.length == 0 || (this.googlePlaceDetails.imageUrls.length == this.googleMapProcessedImages.length);
        if(!processAll)
        {
          this.totalSuggestionImages += this.googleMapProcessedImages.length;
        }
      }
    },
    getFacebookPageDetails(details){
      this.facebookDetails = details;
    },
    async setFacebookDetail(){
      await this.setFacebookPageDetail(this.facebookDetails);
      this.isFbAccessTokenExpired = false;
      await this.getFacebookBusinessImages();
    },
    handleModalClick(){
      if(this.isBusinessLogoModalEnabled || this.isLeadImage){
        this.dialog = true;
        this.$refs.tabs.onResize();
        this.isStockImageActive = true;
      }
      else{
        this.$refs.logo.click();
      }
    },
    addCustomUploadedImage(image){
      if(image){
        var uploadedImageData = {
          url: image.imageUrl,
          dimension: {
            width: image.dimensions.split('x')[1],
            height: image.dimensions.split('x')[0]
          },
          selected: false,
          imageSource: businessImageType.CustomUpload
        };
        if(image.type == imageTypes.lead){
          this.addCustomUploadedLeadImages(uploadedImageData);
        }
        else{
          this.addCustomUploadedLogoImages(uploadedImageData);
        }
      }
    },
    processImage(src){
      return new Promise((resolve, reject)=>{
        let img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = src;
      })
    },
    selectTab(item){
      this.selectedTabId = item.id;
      if(item.id == businessImageType.StockImage){
        this.isStockImageActive = true;
      }
    },
    setLogo() {
      this.$emit('logoSelected', this.imageSelected);
      this.logoFromSuggestion = this.imageSelected;
      this.dialog = false;
    },
    selectImage(img){
      // to remove the border from previous selected card
      if(this.imageSelected === null){
        this.imageSelected = img;
        this.imageSelected.selected = true;
        return;
      }
      this.imageSelected.selected = false;
      this.imageSelected = img;
      this.imageSelected.selected = true;
    },
    selectFromSmallSuggestion(img){
      if(this.imageSelected === null){
        this.imageSelected = img;
        this.imageSelected.selected = true;
        this.$emit('logoSelected', this.imageSelected);
        return;
      }
      this.imageSelected.selected = false;
      this.imageSelected = img;
      this.imageSelected.selected = true;
      this.$emit('logoSelected', this.imageSelected);
    },
    dragEnter(e){
      if(e.target.classList.contains('draggable-section') || e.target.classList.contains('draggable-section-child-element')){
        this.isUploadedImageDragged = true;
      }
    },
    dragLeave(e){
      if(e.relatedTarget.classList.contains('draggable-section')
      || e.relatedTarget.classList.contains('v-overlay')
      || e.relatedTarget.classList.contains('v-dialog')){
        this.isUploadedImageDragged = false;
      }
    },
    drop(event) {
      event.preventDefault();
      this.$refs.logo.files = event.dataTransfer.files;
      this.onChange(event);
      this.isUploadedImageDragged = false;
    },
    onChange(event = null) {
      try {
        this.isImageUploading = true;
        this.isUploadedImageInvalid = false;
        this.$emit('showInvalidBusinessLogoAlert', false);
        var allowedFileTypes = /(\jpg|\jpeg|\png)$/i;
        if(this.$refs.logo.files && !allowedFileTypes.exec(this.$refs.logo.files[0].type)){
          this.isUploadedImageInvalid = true;
          if((this.businessLogo && this.isSmallSuggestion && this.totalSuggestionImages <= this.suggestedBusinessImageCount) || (!this.businessLogo && this.totalSuggestionImages <= this.suggestedBusinessImageCount) && !this.isSubsequent){
            this.$emit('showInvalidBusinessLogoAlert', true);
          }
        }
        this.$emit('uploadImage', this.$refs.logo.files[0]);
        this.$emit('setImage', this.$refs.logo.files[0], true);
        return;
      } finally {
        this.dialog = false;
        this.isImageUploading = false;
      }
    },
    onFilePicked(){
      this.$refs.logo.click();
    },
    deselectImageAfterUpload(){
      if(!this.isImageUploading && this.imageSelected)
      {
        this.imageSelected.selected = false;
        this.imageSelected = null
      }
    },
    setLogoFromSuggestion(){
      if(this.smallSuggestionImages.length){
        this.isFirstImageProcessedInSuggestions = true;
        this.$emit('firstImageProcessed');
        if(!this.businessLogo){
          this.imageSelected = this.smallSuggestionImages[0];
          this.imageSelected.selected = true;
          this.$emit('logoSelected', this.imageSelected);
        }
      }
    },
    setPresetImageItem(item){
      this.setPresetImage(item);
    }
  }
}
</script>
<style lang="scss" scoped>

.logo-preview{
  position:relative;
}

.logo:hover {
  cursor: pointer;
}
.text-decoration-underline{
  text-decoration: underline;
}
.suggestion-font {
 font-size: 12px;
 color: grey;
}
::v-deep .v-tabs {
  min-height: 340px;
  .v-tabs__item {
    opacity: 1 !important;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    margin-top:12px;
    padding: 6px 10px;
  }
  .active-tab {
    background-color: white;
    color: var(--v-primary-base);
    border-top: 4px var(--v-primary-base) solid;
    border-left: 1px var(--v-primary-base) solid;
    border-right: 1px var(--v-primary-base) solid;
  }
  .v-tabs__container{
    border-bottom: 1px solid var(--v-primary-base);
  }
}

::v-deep .v-dialog{
  background-color: white;
}

.no-background-hover::before{
background-color: transparent !important;
}

.upload-logo {
  border: 2px dashed var(--v-primary-base);
  border-radius: 5px;
  background-color: var(--v-primary-variation-2-base);
}

.upload-logo-dragged {
  border: 2px dashed var(--v-primary-base);
  border-radius: 5px;
  background-color: var(--v-primary-variation-1-base);
}

.tab{
  border:2px solid white;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

::v-deep .close-button{
  right: 0;
  top:0;
  .v-btn__content {
    justify-content: end;
  }
}

.modal-text{
  cursor: pointer !important;
  font-size: 14px !important;
}

::v-deep .scroll-container {
  height: 43vh;
  max-height: 43vh;
  width: 100%;
}
.gap{
  gap : 5px
}
.upload-btn-margin{
  margin-left: -16px !important;
  margin-bottom: -4px !important;
}

.upload-image-error-text{
  margin-top: -12px !important;
}
</style>